package com.appcreator.compose.components.basic

import kotlinx.browser.window

actual fun platformCorsWorkAround(value: String): String {
    return if (value.contains("app-creator-content")) {
        value + "&cacheKey=${window.location.origin}"
    } else value
}
